
import React from 'react';
import Icon from 'react-icon-base';

const DmiSuccess = props => (
  <Icon viewBox="0 0 20 20" {...props}>
    <g>
      <g fill="none" fillRule="evenodd">
        <path d="M-2-2h24v24H-2z" />
        <path fill="currentColor" fillRule="nonzero" d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zM8 15l8-8-1.41-1.42L8 12.17 5.41 9.59 4 11l4 4z" />
      </g>
    </g>
  </Icon>
);

export default DmiSuccess;
